"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _FoodMenu = require("../../../FoodMenu.context");
var _modifiers = require("../modifiers");
var _menu = _interopRequireDefault(require("../../../utils/menu"));
var ItemVerticalCard = function ItemVerticalCard(_ref) {
  var id = _ref.id,
    name = _ref.name,
    description = _ref.description,
    price = _ref.price,
    image = _ref.image,
    _ref$imageWidth = _ref.imageWidth,
    imageWidth = _ref$imageWidth === void 0 ? 500 : _ref$imageWidth,
    onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var items = _ref2.items,
      modifierSets = _ref2.modifierSets;
    var item = _menu["default"].getItemById(items, id);
    var itemModifierSetIds = item.modifier_sets;
    var itemModifierSets = _menu["default"].getItemModifierSets(itemModifierSetIds, modifierSets);
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card, {
      className: "fcfm-ivc ".concat(className),
      onClick: onClick
    }, image && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
      src: "".concat(image, "?width=").concat(imageWidth)
    }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Header, {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h5",
      style: {
        flexGrow: 1,
        margin: 0
      }
    }, name), parseFloat(price) > 0 && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h5",
      style: {
        margin: 0
      }
    }, "$", price)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Description, null, description), /*#__PURE__*/_react["default"].createElement(_modifiers.ModifierSetsBasic, {
      modifierSets: itemModifierSets
    })));
  });
};
var _default = ItemVerticalCard;
exports["default"] = _default;